import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { ScrollyArticle } from '../components/ScrollyPage/ScrollyArticle';

const StorySocioekonomi = lazy(
    () => import('../components/ScrollyPage/StorySocioekonomi')
);

export const Route = createFileRoute('/om/socioekonomi')({
    component: Index,
});

function Index() {
    return (
        <ScrollyArticle>
            <Suspense fallback={null}>
                <StorySocioekonomi />
            </Suspense>
        </ScrollyArticle>
    );
}
